// extracted by mini-css-extract-plugin
module.exports = {"noProducts":"index__noProducts___2n6_5","lead":"index__lead___1E_OB","link":"index__link____bJiy","main":"index__main___1G1iL"};